export const encodedUriWithoutResize = (uri) => {
  //fixme: this is different to what's used in CoverPagePreview
  if (uri) {
    return uri
      .replace(/\/resize;.*/i, '')
      .replace(/\/thumbnails\//, '/')
      .replace(/\s/g, '%20');
  }
  return uri;
};